export const dashboard = {
  charts: {
    cta: {
      createInvoice: 'Créer une facture',
      text: 'Dès que votre première facture sera créée, vous pourrez voir vos statistiques ici.',
      title: 'Créer votre première facture',
    },
    labels: {
      copyright: 'Droits d’auteur',
      currentQ: 'Trimestre en cours (T{{ quarter }})',
      expired: 'Échu',
      notExpired: 'Non échu',
      performance: 'Revenus professionnels',
      previousQ: 'Trimestres précédents',
    },
    overview: 'Aperçu',
    overviewChart: 'Graphique avec un aperçu des factures par statut',
    summary: {
      amountInvoices: 'Nombre de factures',
      total: 'Total',
      value: 'Montant',
    },
    totalBilled: 'Total facturé',
    totalBilledChart: 'Graphique avec un aperçu des factures',
    yearSelector: 'Année – {{title}}',
  },
  error: {
    title: 'Erreur lors du chargement de votre tableau de bord.',
  },
  forumPostsSummary: {
    error: 'Posts introuvables',
    link: 'Vers le forum',
    title: 'Derniers posts',
  },
  frameworkAgreement: {
    alreadySigned: 'Vous avez déjà accepté le contrat-cadre.',
    checkboxError: 'Pour commencer, vous devez accepter le contrat-cadre.',
    checkboxLabel: 'J’accepte le contrat-cadre.',
    subtitle: 'Pas de petits caractères ni de clauses cachées, uniquement des accords clairs.',
    title: 'Lisez le contrat-cadre',
  },
  header: {
    actionBlock: {
      button: 'Créer une facture',
      dropdown: {
        client: 'Créer un client',
        creditnote: 'Créer une note de crédit',
        quotation: 'Créer un devis',
      },
    },
  },
  jobPostsSummary: {
    error: 'Missions introuvables',
    link: 'Vers les missions',
    title: 'Dernières missions',
  },
  outstandingInvoices: {
    expired: '{{amount}} échu',
    summary_one: '{{count}} facture',
    summary_other: '{{count}} factures',
    summaryWithExpired_one: '{{count}} facture, dont {{expiredCount}} en retard',
    summaryWithExpired_other: '{{count}} factures, dont {{expiredCount}} en retard',
    table: {
      amount: 'Montant',
      dueDate: 'Date d’échéance',
      invoice: 'Facture',
    },
    title: 'Factures ouvertes',
    toReceive: 'Encore à recevoir',
    viewAll: 'Voir toutes les factures ouvertes',
  },
  progression: {
    progress: '{{completedSteps}} sur {{totalSteps}} terminées',
    steps: {
      completed: 'Terminé :',
      create: 'Créez et activez votre compte',
      createInvoice: {
        text: 'Terminez d’abord les autres étapes',
        title: 'Créez et envoyez votre première facture',
      },
      iban: 'Saisissez votre numéro de compte',
      peppol: 'Enregistrez votre boîte de réception Peppol',
      signAddendum2024: 'Signez l’avenant à votre contrat-cadre avec Creative Shelter',
      signContract: 'Signez votre contrat-cadre',
      signContractModalTitle: 'Signez votre contrat-cadre Creative Shelter',
      uncompleted: 'À faire :',
      vatRegulation: 'Indiquez votre régime de TVA',
    },
    subtitle_one: 'Encore {{count}} étape avant de pouvoir envoyer votre première facture.',
    subtitle_other: 'Encore {{count}} étapes avant de pouvoir envoyer votre première facture.',
    subtitle_zero: 'Vous êtes prêt·e à envoyer votre première facture !',
    title: 'Complétez votre compte',
  },
  stats: {
    copyrightAverage: {
      label: 'Moyenne des droits d’auteur',
      tooltip:
        'Moyenne sur quatre ans de la rémunération en droits d’auteur que vous avez perçue via Creative Shelter.<br>Pourquoi c’est important et comment elle est calculée ? <a href="https://knowledge.creativeshelter.be/hoe-wordt-jouw-gemiddelde-auteursrechten-berekend-op-het-dashboard" target="_blank">Lisez-le ici</a>.',
    },
    copyrightThisYear: {
      label: 'Total des droits d’auteur en {{year}}',
      tooltip:
        'Montant total de la rémunération en droits d’auteur de toutes vos factures payées cette année. <br>Tout sur le plafond annuel de votre rémunération en droits d’auteur, lisez-le <a href="https://www.creativeshelter.be/begroting-hervorming-van-auteursrecht/" target="_blank">ici</a>.',
    },
    error: {
      title: 'Erreur lors du chargement de votre tableau de bord.',
    },
    invoicedSumThisYear: {
      label: 'Total des revenus en {{year}}',
      tooltip: 'Montant total que vous avez déjà facturé cette année via notre plateforme.',
    },
    title: 'Statistiques',
  },
};
